"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DisplayAnimation_1 = __importDefault(require("@web/common/DisplayAnimation"));
(() => {
    const questionElements = Array.from(document.querySelectorAll('.most-frequent-questions .question-container'));
    function close(questionElement) {
        const answer = questionElement.querySelector('.answer');
        if (answer === null) {
            return;
        }
        questionElement.classList.remove('active');
        DisplayAnimation_1.default.slideUp(answer);
    }
    function open(questionElement) {
        const answer = questionElement.querySelector('.answer');
        if (answer === null) {
            return;
        }
        questionElement.classList.add('active');
        DisplayAnimation_1.default.slideDown(answer);
    }
    function closeAll(clickedQuestionElement) {
        questionElements.forEach((questionElement) => {
            if (clickedQuestionElement !== questionElement && questionElement.classList.contains('active')) {
                close(questionElement);
            }
        });
    }
    questionElements.forEach((questionElement) => {
        const question = questionElement.querySelector('.question');
        if (question === null) {
            return;
        }
        question.addEventListener('click', (evt) => {
            evt.preventDefault();
            closeAll(questionElement);
            if (questionElement.classList.contains('active')) {
                close(questionElement);
            }
            else {
                open(questionElement);
            }
        });
    });
})();
